import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import moment from "moment";
import { Link } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Back from "../../common/assets/images/Back.svg";
import Close from "../../common/assets/images/Close.svg";
import {
  TextField,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Autocomplete,
  Card,
  CardContent,
  MenuItem,
  Select,
  Button,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import "../styles/DataEntry.scss";
import * as _ from "lodash";
import { initialState } from "../reducers/InitialState";
import { object } from "prop-types";
import { getPatientDetailsView } from "../reducers/patientDataThunk";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const PatientDetails = (props) => {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = React.useState("panel1");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const patient = useSelector((state) => state.patient);
  const generalInfo = patient.PtDetailsView?.generalInfo;
  const maternalInfo = patient.PtDetailsView?.maternalInfo;
  const apperance = patient.PtDetailsView?.appearsInfo;
  const respInfo = patient.PtDetailsView?.respInfo;
  const cvInfo = patient.PtDetailsView?.cvInfo;
  const cnsInfo = patient.PtDetailsView?.cnsInfo;
  const gitInfo = patient.PtDetailsView?.gitInfo;
  const investigation = patient.PtDetailsView?.investigation;
  const antibiotics = patient.PtDetailsView?.antibiotics;
  const globalRecord = patient.PtDetailsView?.globalRecord;

  const [open, setOpen] = React.useState(false);
  const studyId = props.SelectedPatientDetails?.studyId;
  const readingId = props.SelectedPatientDetails?.reading;

  useEffect(() => {
    const req = { studyId, readingId };
    dispatch(getPatientDetailsView(req));
  }, []);

  const closeDialog = (e) => {
    e.preventDefault();
    props.onClose();
  };

  const handleClose = () => {
    props.onClose();
  };
  return (
    <React.Fragment>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Dialog
          fullWidth={props.fullWidth}
          maxWidth={props.maxWidth}
          open={props.open}
          onClose={props.onClose}
        >
          <DialogTitle>
            <Link
              className="FIle-left"
              onClick={closeDialog}
              style={{ marginRight: "20px" }}
            >
              <img
                src={Back}
                className="file-img-left"
                alt=""
                style={{ width: "12px" }}
              />
            </Link>
            Patient Records
            <Link className="FIle-right-extreme" onClick={closeDialog}>
              <img src={Close} style={{ paddingLeft: "77%" }} alt="" />
            </Link>
          </DialogTitle>
          <DialogContent>
            <div className="datacontent">
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{ background: "#F0F1FC" }}
                >
                  <Typography>Baby Profile</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Type of Record"
                        className="dataentry_label"
                        style={{ display: "block" }}
                      >
                        Type Of Record
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.record_type == "NA"
                          ? "-"
                          : generalInfo?.record_type}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Admission Type"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Admission Type
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_admission_type == "NA"
                          ? "-"
                          : generalInfo?.baby_admission_type}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="POB"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Place Of Birth(Name)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_place_of_birth_name == "NA"
                          ? "-"
                          : generalInfo?.baby_place_of_birth_name}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="DOB"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Date Of Birth
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_birth_date == "NA"
                          ? "-"
                          : moment(generalInfo?.baby_birth_date).format(
                              "DD-MM-YYYY"
                            )}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="POBpin"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Place Of Birth(Pincode)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_place_of_birth_pin_code == "NA"
                          ? "-"
                          : generalInfo?.baby_place_of_birth_pin_code}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="TOB"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Time Of Birth
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_birth_time_hours == "NA"
                          ? "-"
                          : generalInfo?.baby_birth_time_hours}
                      </span>
                      <span className="padetais_cont">
                        {generalInfo?.baby_birth_time_minit == "NA"
                          ? "-"
                          : generalInfo?.baby_birth_time_minit}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Gender"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Gender
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_gender == "NA"
                          ? "-"
                          : generalInfo?.baby_gender}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="DOA"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Date Of Admission
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_date_of_admission == " "
                          ? "-"
                          : moment(generalInfo?.baby_date_of_admission).format(
                              "DD-MM-YYYY"
                            )}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="AAA"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Age at Admission
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_age_of_admission == "NA"
                          ? "-"
                          : generalInfo?.baby_age_of_admission}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="ApgarScore1Min"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Apgar Score 1 Min
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_apgar_score_one_min == "NA"
                          ? "-"
                          : generalInfo?.baby_apgar_score_one_min}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="ApgarScore5Min"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Apgar Score 5 Min
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_apgar_score_five_min == "NA"
                          ? "-"
                          : generalInfo?.baby_apgar_score_five_min}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="ApgarScore10Min"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Apgar Score 10 Min
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_apgar_score_ten_min == "NA"
                          ? "-"
                          : generalInfo?.baby_apgar_score_ten_min}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="ApgarScore1Min"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Place Of Delivery
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_place_of_birth_name == "NA"
                          ? "-"
                          : generalInfo?.baby_place_of_birth_name}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Gestational Age"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Gestational Age
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_gestational_age == "NA"
                          ? "-"
                          : generalInfo?.baby_gestational_age}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Pretern"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Pretern
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_preterm == "NA"
                          ? "-"
                          : generalInfo?.baby_preterm}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Weight At Birth"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Weight at Birth
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_weight_at_birth == "NA"
                          ? "-"
                          : generalInfo?.baby_weight_at_birth}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Weight At Admission"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Weight at Admission
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_weight_at_admission == "NA"
                          ? "-"
                          : generalInfo?.baby_weight_at_admission}
                      </span>
                      <span className="padetais_cont">
                        {generalInfo?.baby_weight_at_admission_unit == "NA"
                          ? "-"
                          : generalInfo?.baby_weight_at_admission_unit}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Day of Sepsis Event"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Day of Sepsis Event
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_day_of_event == "NA"
                          ? "-"
                          : generalInfo?.baby_day_of_event}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Probable Sepsis)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Probable Sepsis)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_day_of_event == "NA"
                          ? "-"
                          : generalInfo?.baby_day_of_event}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (EOS/LOS/NA)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (EOS/LOS/NA)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_condition_yes_eos_los == "NA"
                          ? "-"
                          : generalInfo?.baby_condition_yes_eos_los}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Meningitis)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Meningitis)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.meningitis == "NA"
                          ? "-"
                          : generalInfo?.meningitis}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Umbical Sepsis)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Umbical Sepsis)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.umblical_sepsis == "NA"
                          ? "-"
                          : generalInfo?.umblical_sepsis}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Skin Pustules)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Skin Pustules)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.skin_pustules == "NA"
                          ? "-"
                          : generalInfo?.skin_pustules}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (RDS)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (RDS)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_condition_rds_yes_no == "NA"
                          ? "-"
                          : generalInfo?.baby_condition_rds_yes_no}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Jaundice)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Jaundice)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_condition_jaundice_suspect == "NA"
                          ? "-"
                          : generalInfo?.baby_condition_jaundice_suspect}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (LBW)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (LBW)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_condition_lbw_suspect == "NA"
                          ? "-"
                          : generalInfo?.baby_condition_lbw_suspect}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (TTNB)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (TTNB)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_condition_ttnb_suspect == "NA"
                          ? "-"
                          : generalInfo?.baby_condition_ttnb_suspect}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (LGA/AGA/SGA/NA)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (LGA/AGA/SGA/NA)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_lga_sga_aga_suspect == "NA"
                          ? "-"
                          : generalInfo?.baby_lga_sga_aga_suspect}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Congenital Heart Disease)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Congenital Heart Disease)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.diagCongenitalHeartDisease == "NA"
                          ? "-"
                          : generalInfo?.diagCongenitalHeartDisease}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Anemia)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Anemia)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.baby_condition_anemia_suspect == "NA"
                          ? "-"
                          : generalInfo?.baby_condition_anemia_suspect}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Perinatal Respiratory Depression)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Perinatal Respiratory Depression)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.prelim_diagnosis_perinatal == "NA"
                          ? "-"
                          : generalInfo?.prelim_diagnosis_perinatal}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Hypoglycemia)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Hypoglycemia)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.prelim_diagnosis_hypoglycemia == "NA"
                          ? "-"
                          : generalInfo?.prelim_diagnosis_hypoglycemia}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Hypocalcemia)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Hypocalcemia)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.prelim_diagnosis_hypocalcemia == "NA"
                          ? "-"
                          : generalInfo?.prelim_diagnosis_hypocalcemia}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Feeding Intolerance)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Feeding Intolerance)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.prelim_diagnosis_feeding_intolerence ==
                        "NA"
                          ? "-"
                          : generalInfo?.prelim_diagnosis_feeding_intolerence}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Thrombocytopenia)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Thrombocytopenia)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.thrombocytopenia == "NA"
                          ? "-"
                          : generalInfo?.thrombocytopenia}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (Seizures)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diagnosis (Seizures)
                      </label>
                      <span className="padetais_cont">
                        {generalInfo?.seizures == "NA"
                          ? "-"
                          : generalInfo?.seizures}
                      </span>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{ background: "#F0F1FC" }}
                >
                  <Typography>Mother Profile</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Mother Age"
                        className="dataentry_label"
                        style={{ display: "block" }}
                      >
                        Age
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.mother_age == "NA"
                          ? "-"
                          : maternalInfo?.mother_age}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Weight of the mother"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Weight
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.mother_weight == "NA"
                          ? "-"
                          : maternalInfo?.mother_weight}
                      </span>
                      <span className="padetais_cont">
                        {maternalInfo?.mother_weight_unit == "NA"
                          ? "-"
                          : maternalInfo?.mother_weight_unit}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Height"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Height
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.mother_height == "NA"
                          ? "-"
                          : maternalInfo?.mother_height}
                        {maternalInfo?.mother_height_unit == "NA"
                          ? "-"
                          : maternalInfo?.mother_height_unit}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="BMI"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        BMI
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.mother_bmi == "NA"
                          ? "-"
                          : maternalInfo?.mother_bmi}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Haemoglobin"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Haemoglobin
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.mother_haemoglobin == "NA"
                          ? "-"
                          : maternalInfo?.mother_haemoglobin}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="BPSystolic"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Blood Pressure(Systolic)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.maternal_blood_pressure == "NA"
                          ? "-"
                          : maternalInfo?.maternal_blood_pressure}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="BPDiastolic"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Blood Pressure (Diastolic)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.maternal_blood_pressure_diastolic == "NA"
                          ? "-"
                          : maternalInfo?.maternal_blood_pressure_diastolic}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diabetes"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Diabetes (Present)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.maternal_diabetes == "NA"
                          ? "-"
                          : maternalInfo?.maternal_diabetes}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Fever_present"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Fever (Present)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.maternal_fever == "NA"
                          ? "-"
                          : maternalInfo?.maternal_fever}
                      </span>
                      <span className="padetais_cont">
                        {maternalInfo?.maternal_fever_unit == "NA"
                          ? "-"
                          : maternalInfo?.maternal_fever_unit}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="MaternalFevereDurationCheckBox"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Fever Duration
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.maternal_fever_duration == "NA"
                          ? "-"
                          : maternalInfo?.maternal_fever_duration}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="ThyroidFunction"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Thyroid Function
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.maternal_thyroid_function == "NA"
                          ? "-"
                          : maternalInfo?.maternal_thyroid_function}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="ThyroidFunctionIfAbnormal"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Thyroid Function (If ABNORMAL)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.maternal_thyroid_function_basic == "NA"
                          ? "-"
                          : maternalInfo?.maternal_thyroid_function_basic}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="ThyroidFunctionUnits"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Thyroid Function (TSH)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.maternal_thyroid_function_unit_basic ==
                        "NA"
                          ? "-"
                          : maternalInfo?.maternal_thyroid_function_unit_basic}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="ThyroidFunctionUnits"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Thyroid Function (T3)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.maternal_thyroid_t3 == "NA"
                          ? "-"
                          : maternalInfo?.maternal_thyroid_t3}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="ThyroidFunctionUnits"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Thyroid Function (T4)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.maternal_thyroid_t4 == "NA"
                          ? "-"
                          : maternalInfo?.maternal_thyroid_t4}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="MoreThan3VaginalExaminationDuringLabor"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        More than 3 Vaginal Examinations During Labor
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.more_than_3_vaginal_examinations_during_labor ==
                        "NA"
                          ? "-"
                          : maternalInfo?.more_than_3_vaginal_examinations_during_labor}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="LeakingPV"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Leaking PV
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.leaking_pv == "NA"
                          ? "-"
                          : maternalInfo?.leaking_pv}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Rupture of Membranes"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Rupture Of Membranes (ROM)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.rupture_of_membranes_rom == "NA"
                          ? "-"
                          : maternalInfo?.rupture_of_membranes_rom}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="PIH"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Pregnancy-induced hypertension (PIH)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.pih == "NA" ? "-" : maternalInfo?.pih}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="ROM Type"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Rupture Of Membranes (Type)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.rupture_of_membranes_rom == "NA"
                          ? "-"
                          : maternalInfo?.rupture_of_membranes_rom}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="ROM If PROM"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Rupture Of Membranes(IF PROM)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.rupture_of_membranes_rom_two == "NA"
                          ? "-"
                          : maternalInfo?.rupture_of_membranes_rom_two}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis (EOS/LOS/NA)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Smelly Amniotic Fluid
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.smelly_amniotic_fluid == "NA"
                          ? "-"
                          : maternalInfo?.smelly_amniotic_fluid}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Diagnosis Chorioamnionitis"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Chorioamnionitis
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.chorioamnionitis == "NA"
                          ? "-"
                          : maternalInfo?.chorioamnionitis}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="GBS Infection"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        GBS Infection
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.gbs_infection == "NA"
                          ? "-"
                          : maternalInfo?.gbs_infection}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Urinary Tract Infection"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Urinary Tract Infection
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.colonisation_or_urinary_tract_infection ==
                        "NA"
                          ? "-"
                          : maternalInfo?.colonisation_or_urinary_tract_infection}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Torch Infection"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Torch Infection
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.torch_infections == "NA"
                          ? "-"
                          : maternalInfo?.torch_infections}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Type of Delivery"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Type Of Delivery
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.type_of_delivery == "NA"
                          ? "-"
                          : maternalInfo?.type_of_delivery}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Delayed Cord Clamping"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Delayed Cord Clamping
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.delayed_cord_clamping == "NA"
                          ? "-"
                          : maternalInfo?.delayed_cord_clamping}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Vaginal Swab Culture (Done)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Vaginal Swab Culture (Done)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.vaginal_swab_culture == "NA"
                          ? "-"
                          : maternalInfo?.vaginal_swab_culture}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Vaginal Swab Culture (Result)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Vaginal Swab Culture (Result)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.vaginal_swab_culture_two == "NA"
                          ? "-"
                          : maternalInfo?.vaginal_swab_culture_two}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Vaginal Swab Culture"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Vaginal Swab Culture (pH Value)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.vaginal_swab_culture_three == "NA"
                          ? "-"
                          : maternalInfo?.vaginal_swab_culture_three}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Amniotic Fluid Culture (Done)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Amniotic Fluid Culture (Done)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.amniotic_fluid_culture == "NA"
                          ? "-"
                          : maternalInfo?.amniotic_fluid_culture}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor="Amniotic Fluid Culture (Result)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        Amniotic Fluid Culture (Result)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.amniotic_fluid_culture_two == "NA"
                          ? "-"
                          : maternalInfo?.amniotic_fluid_culture_two}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label
                        htmlFor=" AF Culture (If Positive)"
                        style={{ display: "block" }}
                        className="dataentry_label"
                      >
                        AF Index Culture (if Positive)
                      </label>
                      <span className="padetais_cont">
                        {maternalInfo?.amniotic_fluid_culture_three == "NA"
                          ? "-"
                          : maternalInfo?.amniotic_fluid_culture_three}
                      </span>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              {globalRecord?.entity_type == "Invasive" ? (
                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChange("panel3")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{ background: "#F0F1FC" }}
                  >
                    <Typography>Baby Apperance</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor=" Reading Date"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Reading Date
                        </label>

                        <span className="padetais_cont">
                          {moment(apperance?.reading_date).format("DD-MM-YYYY")}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Admission Type"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Time of Reading (0-23 Hours)
                        </label>
                        <span className="padetais_cont">
                          {apperance?.time_of_reading_hours} Hrs
                        </span>
                        <span
                          className="padetais_cont"
                          style={{ paddingLeft: "10px" }}
                        >
                          {apperance?.time_of_reading_minute} Mins
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Record Id"
                          className="padetais_label"
                          style={{ display: "block", color: "#878787" }}
                        >
                          Weight of Baby
                        </label>
                        <span className="padetais_cont">
                          {apperance?.baby_weight_at_birth}
                        </span>
                        <span
                          className="padetais_cont"
                          style={{ paddingLeft: "10px" }}
                        >
                          {apperance?.baby_weight_at_birth_unit}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label htmlFor="Record Id" className="padetais_label">
                          Appearance
                        </label>
                        <span className="padetais_cont">
                          {apperance?.baby_appearance}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Skin Colour"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Skin Colour
                        </label>
                        <span className="padetais_cont">
                          {apperance?.baby_skin_colour == "NA"
                            ? "-"
                            : apperance?.baby_skin_colour}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Cry Sound"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Cry Sound
                        </label>
                        <span className="padetais_cont">
                          {apperance?.baby_cry_sound == "NA"
                            ? "-"
                            : apperance?.baby_cry_sound}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Cry Sound"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Duration(If Not Cried)
                        </label>
                        <span className="padetais_cont">
                          {apperance?.baby_cry_sound_status == "NA"
                            ? "-"
                            : apperance?.baby_cry_sound_status}
                        </span>
                        {apperance?.baby_cry_sound_status == "NA"
                          ? " "
                          : "Secs"}
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Hypotonia Muscular Response (1 min after birth)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Hypotonia Muscular Response <br />
                          (1 min after birth)
                        </label>
                        <span className="padetais_cont">
                          {apperance?.hypotonia_muscular_response_five_min_after_birth ==
                          "NA"
                            ? "-"
                            : apperance?.hypotonia_muscular_response_five_min_after_birth}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Hypotonia Muscular Response (5 min after birth)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Hypotonia Muscular Response <br />
                          (5 min after birth)
                        </label>
                        <span className="padetais_cont">
                          {apperance?.baby_cry_sound_status == "NA"
                            ? "-"
                            : apperance?.baby_cry_sound_status}
                        </span>
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Hypothermia"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Hypothermia
                        </label>
                        <span className="padetais_cont">
                          {apperance?.hypothermia == "NA"
                            ? "-"
                            : apperance?.hypothermia}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Weight At Birth"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Hypothermia (Units)
                        </label>
                        <span className="padetais_cont">
                          {apperance?.hypothermia_status_value == "NA"
                            ? "-"
                            : apperance?.hypothermia_status_value}
                        </span>
                        <span
                          className="padetais_cont"
                          style={{ paddingLeft: "10px" }}
                        >
                          {apperance?.hypothermia_status == "NA"
                            ? "-"
                            : apperance?.hypothermia_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Excessive Sleeping"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Excessive Sleeping
                        </label>
                        <span className="padetais_cont">
                          {apperance?.excessive_sleeping == "NA"
                            ? "-"
                            : apperance?.excessive_sleeping}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="baby_feeding_status"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Feeding Status
                        </label>
                        <span className="padetais_cont">
                          {apperance?.baby_feeding_status == "NA"
                            ? "-"
                            : apperance?.baby_feeding_status}
                        </span>
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="baby_presence_of_convulsions"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Presence Of Convulsions
                        </label>
                        <span className="padetais_cont">
                          {apperance?.baby_presence_of_convulsions == "NA"
                            ? "-"
                            : apperance?.baby_presence_of_convulsions}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="baby_jaundice"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Jaundice (Present)
                        </label>
                        <span className="padetais_cont">
                          {apperance?.baby_jaundice == "NA"
                            ? "-"
                            : apperance?.baby_jaundice}
                        </span>
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="breast_feeding_initiation"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Breast Feeding Initiation
                        </label>
                        <span className="padetais_cont">
                          {apperance?.breast_feeding_initiation == "NA"
                            ? "-"
                            : apperance?.breast_feeding_initiation}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Kangaroo Mother Care"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Kangaroo Mother Care
                        </label>
                        <span className="padetais_cont">
                          {apperance?.kangaroo_mother_care == "NA"
                            ? "-"
                            : apperance?.kangaroo_mother_care}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="umbilical_redness"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Umbilical Redness
                        </label>
                        <span className="padetais_cont">
                          {apperance?.umbilical_redness == "NA"
                            ? "-"
                            : apperance?.umbilical_redness}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="umbilical_enduration"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Umbilical Enduration
                        </label>
                        <span className="padetais_cont">
                          {apperance?.umbilical_enduration == "NA"
                            ? "-"
                            : apperance?.umbilical_enduration}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="umbilical_discharge"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Umbilical Discharge
                        </label>
                        <span className="padetais_cont">
                          {apperance?.umbilical_discharge == "NA"
                            ? "-"
                            : apperance?.umbilical_discharge}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="skin_pustules"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Skin Pustules {">"} 5
                        </label>
                        <span className="padetais_cont">
                          {apperance?.skin_pustules == "NA"
                            ? "-"
                            : apperance?.skin_pustules}
                        </span>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ) : null}
              {globalRecord?.entity_type == "Invasive" ? (
                <Accordion
                  expanded={expanded === "panel4"}
                  onChange={handleChange("panel4")}
                >
                  <AccordionSummary
                    aria-controls="panel2d-content"
                    id="panel2d-header"
                    style={{ background: "#F0F1FC" }}
                  >
                    <Typography>Baby Respiratory</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Groaning"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Groaning
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.groaning == "NA"
                            ? "-"
                            : respInfo?.groaning}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Grunting"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Grunting
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.grunting == "NA"
                            ? "-"
                            : respInfo?.grunting}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Stridor"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Stridor
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.stridor == "NA" ? "-" : respInfo?.stridor}
                        </span>
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Retraction"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Retraction
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.retraction == "NA"
                            ? "-"
                            : respInfo?.retraction}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Fast Breathing"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Fast Breathing
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.fast_breathing == "NA"
                            ? "-"
                            : respInfo?.fast_breathing}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Oxygen Saturation"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Oxygen Saturation
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.oxygen_saturation == "NA"
                            ? "-"
                            : respInfo?.oxygen_saturation}
                          {respInfo?.oxygen_saturation == "NA" ? " " : "%"}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Breathing Rate"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Breathing Rate (Breaths Per Minute)
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.breathing_rate == "NA"
                            ? "-"
                            : respInfo?.breathing_rate}
                        </span>
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Chest In-drawing"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Chest In-drawing
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.baby_chest_indrawing == "NA"
                            ? "-"
                            : respInfo?.baby_chest_indrawing}
                        </span>
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="X-Ray Status"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          X-Ray Status (Done)
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.x_ray_status == "NA"
                            ? "-"
                            : respInfo?.x_ray_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="X-Ray Result"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          X-Ray Result
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.x_ray_result == "NA"
                            ? "-"
                            : respInfo?.x_ray_result}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="X-Ray Diagnosis (if Abnormal)"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          X-Ray Diagnosis (if Abnormal)
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.x_ray_diagnosis_any_other == "NA"
                            ? "-"
                            : respInfo?.x_ray_diagnosis_any_other}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Apnea Status (Presence)"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Apnea Status (Presence)
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.apnea_status == "NA"
                            ? "-"
                            : respInfo?.apnea_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Apnea Diagnosis"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Apnea Diagnosis
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.apnea_diagnosis == "NA"
                            ? "-"
                            : respInfo?.apnea_diagnosis}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Respiratory Support"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Respiratory Support
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.baby_respiratory_support == "NA"
                            ? "-"
                            : respInfo?.baby_respiratory_support}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Respiratory Support (Type)"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Respiratory Support (Type)
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.baby_respiratory_support_if_yes == "[]"
                            ? "-"
                            : respInfo?.baby_respiratory_support_if_yes}
                        </span>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ) : null}
              {globalRecord?.entity_type == "Invasive" ? (
                <Accordion
                  expanded={expanded === "panel5"}
                  onChange={handleChange("panel5")}
                >
                  <AccordionSummary
                    aria-controls="panel3d-content"
                    id="panel3d-header"
                    style={{ background: "#F0F1FC" }}
                  >
                    <Typography>Baby Cardio Vascular Function</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="HeartRate"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Heart Rate
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.heart_rate == "NA"
                            ? "-"
                            : cvInfo?.heart_rate}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="UrineOutput"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Urine Output
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.baby_cry_sound_status == "NA"
                            ? "-"
                            : cvInfo?.baby_cry_sound_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="BPSystolic"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          BP (Systolic)
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.baby_cry_sound_status == "NA"
                            ? "-"
                            : cvInfo?.baby_cry_sound_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="BPDiastolic"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          BP (Diastolic)
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.baby_cry_sound_status == "NA"
                            ? "-"
                            : cvInfo?.baby_cry_sound_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="BPMeanArterial"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          BP (Mean Arterial)
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.baby_cry_sound_status == "NA"
                            ? "-"
                            : cvInfo?.baby_cry_sound_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="CapillaryRefill"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Capillary Refill
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.urine_output == "NA"
                            ? "-"
                            : cvInfo?.urine_output}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="LowPeripheralPulseVolume"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Low Peripheral Pulse Volume
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.low_peripheral_pulse_volume == "NA"
                            ? "-"
                            : cvInfo?.low_peripheral_pulse_volume}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="CoolPeripheries"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Cool Peripheries
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.cool_peripheries == "NA"
                            ? "-"
                            : cvInfo?.cool_peripheries}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="2DEchoDone"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          2D Echo (Done)
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.baby_cry_sound_status == "NA"
                            ? "-"
                            : cvInfo?.baby_cry_sound_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="2DEchoResultIfYes"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          2D Echo Result (If Yes)
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.two_d_echo_done == "NA"
                            ? "-"
                            : cvInfo?.two_d_echo_done}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Ionotropes"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Ionotropes
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.baby_on_ionotropes == "NA"
                            ? "-"
                            : cvInfo?.baby_on_ionotropes}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="BabyOnCentralLines"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Central Lines(Yes/No/NA)
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.central_line == "NA"
                            ? "-"
                            : cvInfo?.central_line}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="CentralLineValue"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Central Lines
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.central_line_value == "NA"
                            ? "-"
                            : cvInfo?.central_line_value}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor=" Central Lines Insert Date"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Central Lines(Insert Date)
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.central_line_insert_date == "NA"
                            ? "-"
                            : cvInfo?.central_line_insert_date}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor=" Central Lines Removed Date"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Central Lines(Removed Date)
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.central_line_removed_date == "NA"
                            ? "-"
                            : cvInfo?.central_line_removed_date}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Infusion of Blood Products"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Infusion of Blood Products
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.infusion_of_blood_products == "NA"
                            ? "-"
                            : cvInfo?.infusion_of_blood_products}
                        </span>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ) : null}
              {globalRecord?.entity_type == "Invasive" ? (
                <Accordion
                  expanded={expanded === "panel6"}
                  onChange={handleChange("panel6")}
                >
                  <AccordionSummary
                    aria-controls="panel4d-content"
                    id="panel4d-header"
                    style={{ background: "#F0F1FC" }}
                  >
                    <Typography>Baby CNS Function</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="FeaturesOfEncephalopathy"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Features of Encephalopathy
                        </label>
                        <span className="padetais_cont">
                          {cnsInfo?.features_of_encephalopathy == "NA"
                            ? "-"
                            : cnsInfo?.features_of_encephalopathy}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Seizures"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Seizures
                        </label>
                        <span className="padetais_cont">
                          {cnsInfo?.seizures == "NA" ? "-" : cnsInfo?.seizures}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="AbnormalMovementsLikeTonicPosturing"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Abnormal Movements like Tonic Posturing
                        </label>
                        <span className="padetais_cont">
                          {cnsInfo?.abnormal_movements_like_tonic_posturing ==
                          "NA"
                            ? "-"
                            : cnsInfo?.abnormal_movements_like_tonic_posturing}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="AFBulge"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          AF Bulge
                        </label>
                        <span className="padetais_cont">
                          {cnsInfo?.af_bulge == "NA" ? "-" : cnsInfo?.af_bulge}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="BabyMovementWithStimulation"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Baby Movement with Stimulation
                        </label>
                        <span className="padetais_cont">
                          {cnsInfo?.baby_movement == "NA"
                            ? "-"
                            : cnsInfo?.baby_movement}
                        </span>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ) : null}
              {globalRecord?.entity_type == "Invasive" ? (
                <Accordion
                  expanded={expanded === "panel7"}
                  onChange={handleChange("panel7")}
                >
                  <AccordionSummary
                    aria-controls="panel5d-content"
                    id="panel5d-header"
                    style={{ background: "#F0F1FC" }}
                  >
                    <Typography>Baby GI Tract Function</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="AbdominalDistension"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Abdominal Distension
                        </label>
                        <span className="padetais_cont">
                          {gitInfo?.abdominal_dystension == "NA"
                            ? "-"
                            : gitInfo?.abdominal_dystension}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="FrequencyOfStools"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Frequency of Stools
                        </label>
                        <span className="padetais_cont">
                          {gitInfo?.baby_cry_sound_status == "NA"
                            ? "-"
                            : gitInfo?.baby_cry_sound_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Diarrhea"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Diarrhea
                        </label>
                        <span className="padetais_cont">
                          {gitInfo?.baby_cry_sound_status == "NA"
                            ? "-"
                            : gitInfo?.baby_cry_sound_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Vomiting"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Vomiting
                        </label>
                        <span className="padetais_cont">
                          {gitInfo?.baby_cry_sound_status == "NA"
                            ? "-"
                            : gitInfo?.baby_cry_sound_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="FeedingIntolerance"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Feeding Intolerance
                        </label>
                        <span className="padetais_cont">
                          {gitInfo?.baby_cry_sound_status == "NA"
                            ? "-"
                            : gitInfo?.baby_cry_sound_status}
                        </span>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ) : null}
              {globalRecord?.entity_type == "Invasive" ? (
                <Accordion
                  expanded={expanded === "panel8"}
                  onChange={handleChange("panel8")}
                >
                  <AccordionSummary
                    aria-controls="panel6d-content"
                    id="panel6d-header"
                    style={{ background: "#F0F1FC" }}
                  >
                    <Typography>Baby Investigations</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Thyroid Status"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Thyroid Status
                        </label>
                        <span className="padetais_cont">
                          {investigation?.baby_thyroid_status == "NA"
                            ? "-"
                            : investigation?.baby_thyroid_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Thyroid Result"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Thyroid Result (TSH)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.baby_thyroid_result == "NA"
                            ? "-"
                            : investigation?.baby_thyroid_result}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Thyroid Result (T3)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Thyroid Result (T3)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.baby_thyroid_t3 == "NA"
                            ? "-"
                            : investigation?.baby_thyroid_t3}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Thyroid Result (T4)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Thyroid Result (T4)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.baby_thyroid_t4 == "NA"
                            ? "-"
                            : investigation?.baby_thyroid_t4}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Blood Glucose"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Blood Glucose
                        </label>
                        <span className="padetais_cont">
                          {investigation?.baby_blood_glucose == "NA"
                            ? "-"
                            : investigation?.baby_blood_glucose}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Haemoglobin Level"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Haemoglobin Level
                        </label>
                        <span className="padetais_cont">
                          {investigation?.baby_haemoglobin_levels == "NA"
                            ? "-"
                            : investigation?.baby_haemoglobin_levels}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="C-Reactive Protein Result"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          C-Reactive Protein Result
                        </label>
                        <span className="padetais_cont">
                          {investigation?.baby_c_reactive_protien_result == "NA"
                            ? "-"
                            : investigation?.baby_c_reactive_protien_result}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="C-Reactive Protein Level"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          C-Reactive Protein Level
                        </label>
                        <span className="padetais_cont">
                          {investigation?.baby_c_reactive_protien_levels == "NA"
                            ? "-"
                            : investigation?.baby_c_reactive_protien_levels}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Micro ESR"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Micro ESR Level (1st Hr)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.micro_esr == "NA"
                            ? "-"
                            : investigation?.micro_esr}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Procalcitonin"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Procalcitonin Level
                        </label>
                        <span className="padetais_cont">
                          {investigation?.baby_procalcitonin_levels == "NA"
                            ? "-"
                            : investigation?.baby_procalcitonin_levels}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Prothrombin Type(PT)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Prothrombin Time (PT)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.prothrombin_type == "NA"
                            ? "-"
                            : investigation?.prothrombin_type}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Activated Partial Prothrombin"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Activated Partial Prothrombin
                        </label>
                        <span className="padetais_cont">
                          {investigation?.activated_partial_prothrombine_type ==
                          "NA"
                            ? "-"
                            : investigation?.activated_partial_prothrombine_type}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Total Leucocytes Count"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Total Leucocytes Count
                        </label>
                        <span className="padetais_cont">
                          {investigation?.total_leucocute_count == "NA"
                            ? "-"
                            : investigation?.total_leucocute_count}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Absolute Neutrophil Count"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Absolute Neutrophil Count
                        </label>
                        <span className="padetais_cont">
                          {investigation?.absolute_neutrophil_count == "NA"
                            ? "-"
                            : investigation?.absolute_neutrophil_count}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Immature To Mature Neutrophil(I/T) Ratio"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Immature to mature neutrophil ratios {">"} 0.2
                        </label>
                        <span className="padetais_cont">
                          {investigation?.immature_to_mature_neutrophil_ratios ==
                          "NA"
                            ? "-"
                            : investigation?.immature_to_mature_neutrophil_ratios}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Thrombocytopenia (Platelet Count)"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Thrombocytopenia (Platelet Count)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.thrombocytopenia == "NA"
                            ? "-"
                            : investigation?.thrombocytopenia}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Urine test for Pus Cells"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Urine test for Pus Cells (If {">"} 4 pus cells/HPF)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.baby_cry_sound_status == "NA"
                            ? "-"
                            : investigation?.baby_cry_sound_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Urine culture test"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Urine Culture Test Result
                        </label>
                        <span className="padetais_cont">
                          {investigation?.urine_rest_for_pus_cells == "NA"
                            ? "-"
                            : investigation?.urine_rest_for_pus_cells}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Blood Culture Result"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Blood Culture Test Result (BCTR)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.blood_culture_report == "NA"
                            ? "-"
                            : investigation?.blood_culture_report}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Gram Positive Bacteria"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Gram Positive Bacteria (If BCTR Positive)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.gram_positive_bacteria == "NA"
                            ? "-"
                            : investigation?.gram_positive_bacteria}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Gram Positive Bacteria"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Gram Positive Bacteria (If Other)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.gram_positive_bacteria_if_other ==
                          "NA"
                            ? "-"
                            : investigation?.gram_positive_bacteria_if_other}
                        </span>
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Gram Negative Bacteria"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Gram Negative Bacteria (If BCTR Positive)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.gram_negative_bacteria == "NA"
                            ? "-"
                            : investigation?.gram_negative_bacteria}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Gram Negative Bacteria (Other)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Gram Negative Bacteria (Other)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.gram_negative_bacteria_if_other ==
                          "NA"
                            ? "-"
                            : investigation?.gram_negative_bacteria_if_other}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="FUNGI"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          FUNGI (If BCTR Positive)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.fungi == "NA"
                            ? "-"
                            : investigation?.fungi}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Other Organism"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Other Organism (If BCTR Positive)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.other_organism == "NA"
                            ? "-"
                            : investigation?.other_organism}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Antibiotic Status Sensitive"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Antimicrobial Testing ( Sensitive)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.antibiotic_status == "NA"
                            ? "-"
                            : investigation?.antibiotic_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Antibiotic Status Resisitant"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Antimicrobial Testing ( Resisitant )
                        </label>
                        <span className="padetais_cont">
                          {investigation?.antibiotic_status_resisitant == "NA"
                            ? "-"
                            : investigation?.antibiotic_status_resisitant}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Antibiotic Status Intermediate"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Antimicrobial Testing ( Intermediate )
                        </label>
                        <span className="padetais_cont">
                          {investigation?.antibiotic_status_intermediate == "NA"
                            ? "-"
                            : investigation?.antibiotic_status_intermediate}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Sodium (Na)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Sodium Level (Na)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.sodium == "NA"
                            ? "-"
                            : investigation?.sodium}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Potassium (K)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Potassium Level(K)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.potassium == "NA"
                            ? "-"
                            : investigation?.potassium}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Chloride"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Chloride Level
                        </label>
                        <span className="padetais_cont">
                          {investigation?.chlorine == "NA"
                            ? "-"
                            : investigation?.chlorine}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Calcium (Ca)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Calcium Level(Ca)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.calcium == "NA"
                            ? "-"
                            : investigation?.calcium}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Phosphate (PO4)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Phosphate Level(PO4)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.phosphate == "NA"
                            ? "-"
                            : investigation?.phosphate}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Magnesium (Mg)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Magnesium Level(Mg)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.magnesium == "NA"
                            ? "-"
                            : investigation?.magnesium}
                        </span>
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Urea"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Urea Level
                        </label>
                        <span className="padetais_cont">
                          {investigation?.urea == "NA"
                            ? "-"
                            : investigation?.urea}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Creatinine"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Creatinine Level
                        </label>
                        <span className="padetais_cont">
                          {investigation?.creatinine == "NA"
                            ? "-"
                            : investigation?.creatinine}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Lactate level"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Lactate level
                        </label>
                        <span className="padetais_cont">
                          {investigation?.lactate_levels == "NA"
                            ? "-"
                            : investigation?.lactate_levels}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Bilirubin level"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Bilirubin level
                        </label>
                        <span className="padetais_cont">
                          {investigation?.bilirubin_levels == "NA"
                            ? "-"
                            : investigation?.bilirubin_levels}
                        </span>
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Cord pH"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Cord pH
                        </label>
                        <span className="padetais_cont">
                          {investigation?.cord_ph == "NA"
                            ? "-"
                            : investigation?.cord_ph}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="ECG - Arrhythmia (Present)"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          ECG - Arrhythmia (Present)
                        </label>
                        <span className="padetais_cont">
                          {investigation?.arrhythmia == "NA"
                            ? "-"
                            : investigation?.arrhythmia}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="CSF Culture Value"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          CSF Culture Result
                        </label>
                        <span className="padetais_cont">
                          {investigation?.csf_culture == "NA"
                            ? "-"
                            : investigation?.csf_culture}
                        </span>
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="TSB Value (mg/dl)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          TSB Value
                        </label>
                        <span className="padetais_cont">
                          {investigation?.csf_culture_tsb_value == "NA"
                            ? "-"
                            : investigation?.csf_culture_tsb_value}
                        </span>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ) : null}
              {globalRecord?.entity_type == "Invasive" ? (
                <Accordion
                  expanded={expanded === "panel9"}
                  onChange={handleChange("panel9")}
                >
                  <AccordionSummary
                    aria-controls="panel7d-content"
                    id="panel7d-header"
                    style={{ background: "#F0F1FC" }}
                  >
                    <Typography>Antiobiotic Administration</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Antibiotic Given"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Antibiotic Given
                        </label>
                        <span className="padetais_cont">
                          {antibiotics?.antibiotic_given == "NA"
                            ? "-"
                            : antibiotics?.antibiotic_given}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Date of administration"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Date of Anti Biotic Administration
                        </label>
                        <span className="padetais_cont">
                          {antibiotics?.date_of_administration_of_antiobiotic ==
                          "NA"
                            ? "-"
                            : antibiotics?.date_of_administration_of_antiobiotic}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Time of Administration"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Time of Anti Biotic Administration (0 - 23 Hrs)
                        </label>
                        <span className="padetais_cont">
                          {antibiotics?.time_of_administration_of_antiobiotic_hours ==
                          "NA"
                            ? "-"
                            : antibiotics?.time_of_administration_of_antiobiotic_hours}
                        </span>
                        <span>
                          {antibiotics?.time_of_administration_of_antiobiotic_minute ==
                          "NA"
                            ? "-"
                            : antibiotics?.time_of_administration_of_antiobiotic_minute}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Antibiotic Name"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Antibiotic Name
                        </label>
                        <span className="padetais_cont">
                          {antibiotics?.antibiotic_name == "NA"
                            ? "-"
                            : antibiotics?.antibiotic_name}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Antibiotic Name (Other)"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Antibiotic Name (Other)
                        </label>
                        <span className="padetais_cont">
                          {antibiotics?.antibiotic_name_if_other == "NA"
                            ? "-"
                            : antibiotics?.antibiotic_name_if_other}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Blood Samples for Culture test"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Blood Sample Collection Date
                        </label>
                        <span className="padetais_cont">
                          {antibiotics?.date_of_blood_samples_sent_for_culture_test ==
                          "NA"
                            ? "-"
                            : antibiotics?.date_of_blood_samples_sent_for_culture_test}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Time of Blood Samples"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Blood Sample Collection Time
                        </label>
                        <span className="padetais_cont">
                          {antibiotics?.time_of_blood_samples_sent_for_culture_test_hours ==
                          "NA"
                            ? "-"
                            : antibiotics?.time_of_blood_samples_sent_for_culture_test_hours}
                        </span>
                        <span>
                          {antibiotics?.time_of_blood_samples_sent_for_culture_test_minute ==
                          "NA"
                            ? "-"
                            : antibiotics?.time_of_blood_samples_sent_for_culture_test_minute}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Antibiotic Given"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Antibiotic Given Prior to Blood Sample Collection
                        </label>
                        <span className="padetais_cont">
                          {antibiotics?.blood_sample_taken_prior_to_antiobiotic_administration ==
                          "NA"
                            ? "-"
                            : antibiotics?.blood_sample_taken_prior_to_antiobiotic_administration}
                        </span>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ) : null}
              {globalRecord?.entity_type == "Non-Invasive" ? (
                <Accordion
                  expanded={expanded === "panel10"}
                  onChange={handleChange("panel10")}
                >
                  <AccordionSummary
                    aria-controls="panel5d-content"
                    id="panel5d-header"
                    style={{ background: "#F0F1FC" }}
                  >
                    <Typography>Baby Health Parameters</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="AbdominalDistension"
                          className="padetais_label"
                          style={{ display: "block" }}
                        >
                          Appearance
                        </label>
                        <span className="padetais_cont">
                          {apperance?.baby_appearance == "NA"
                            ? "-"
                            : apperance?.baby_appearance}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="FrequencyOfStools"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Breast Feeding Initiation
                        </label>
                        <span className="padetais_cont">
                          {apperance?.breast_feeding_initiation == "NA"
                            ? "-"
                            : apperance?.breast_feeding_initiation}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Feeding Status"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Feeding Status
                        </label>
                        <span className="padetais_cont">
                          {apperance?.baby_feeding_status == "NA"
                            ? "-"
                            : apperance?.baby_feeding_status}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor=" BP (Systolic)"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          BP (Systolic)
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.baby_blood_pressure_upper_limb == "NA"
                            ? "-"
                            : cvInfo?.baby_blood_pressure_upper_limb}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor=" BP (Diastolic)"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          BP (Diastolic)
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.baby_blood_pressure_lower_limb == "NA"
                            ? "-"
                            : cvInfo?.baby_blood_pressure_lower_limb}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="BP (Mean Arterial)"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          BP (Mean Arterial)
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.baby_blood_pressure_mean_arterial_bp == "NA"
                            ? "-"
                            : cvInfo?.baby_blood_pressure_mean_arterial_bp}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Urine Output"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Urine Output
                        </label>
                        <span className="padetais_cont">
                          {cvInfo?.urine_output == "NA"
                            ? "-"
                            : cvInfo?.urine_output}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Frequency of Stools"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Frequency of Stools
                        </label>
                        <span className="padetais_cont">
                          {gitInfo?.frequency_of_stools == "NA"
                            ? "-"
                            : gitInfo?.frequency_of_stools}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Vomiting"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Vomiting
                        </label>
                        <span className="padetais_cont">
                          {gitInfo?.vomiting == "NA" ? "-" : gitInfo?.vomiting}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Abdominal Distension"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Abdominal Distension
                        </label>
                        <span className="padetais_cont">
                          {gitInfo?.abdominal_dystension == "NA"
                            ? "-"
                            : gitInfo?.abdominal_dystension}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Baby Movement with Stimulation"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Baby Movement with Stimulation
                        </label>
                        <span className="padetais_cont">
                          {cnsInfo?.baby_movement == "NA"
                            ? "-"
                            : cnsInfo?.baby_movement}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Retraction"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Retraction
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.retraction == "NA"
                            ? "-"
                            : respInfo?.retraction}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor="Fast Breathing"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Fast Breathing
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.fast_breathing == "NA"
                            ? "-"
                            : respInfo?.fast_breathing}
                        </span>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label
                          htmlFor=" Chest In-drawing"
                          style={{ display: "block" }}
                          className="padetais_label"
                        >
                          Chest In-drawing
                        </label>
                        <span className="padetais_cont">
                          {respInfo?.baby_chest_indrawing == "NA"
                            ? "-"
                            : respInfo?.baby_chest_indrawing}
                        </span>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ) : null}
            </div>
          </DialogContent>
        </Dialog>
      </LocalizationProvider>
    </React.Fragment>
  );
};

export default PatientDetails;
